import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Overlay,
  Popover,
  Image,
} from "react-bootstrap";
import "assets/css/Contact/contact.css";
import { toast } from "react-toastify";
import { BsThreeDotsVertical } from "react-icons/bs";
import TrashIcon from "assets/img/icons/Trash-01 (1).svg";
import BlockIcon from "assets/img/icons/Block Contact-01.svg";
import ChatIcon from "assets/img/icons/chat-1.png";
import EditIcon from "assets/img/icons/edit.svg";
import CallIcon from "assets/img/icons/Call-01.svg";
import EditContact from "./Modal/EditContact";
import ContactMessage from "./Modal/ContactMessage";
import AddContactNoteModal from "./Modal/addContactNote";
import { useSelector, useDispatch } from "react-redux";
import {contactDetailAction, ResetContactDataAction} from "../../Redux/Contacts/action";
import moment from "moment";
import "../../assets/css/Loaders/ContactDetails.css";
import {ResetDataAction} from "../../Redux/Inbound/actions";
export default function ContactDetails({ id }) {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.contactsReducer.ContactDetails);
  const [showData, setShowData] = useState("About");
  const [showPopover, setShowPopover] = useState(false);
  const [target, setTarget] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleCloseNoteModal = () => setShowNoteModal(false);
  const handleShowNoteModal = () => setShowNoteModal(true);

  const handleCloseMessageModal = () => setShowMessageModal(false);
  const handleShowMessageModal = () => setShowMessageModal(true);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  useEffect(() => {
    async function fetchData() {
      if (id) {
        setLoader(true);
        await contactDetailAction(dispatch, id);
        setLoader(false);
      }
    }
    fetchData();
  }, [id]);

  useEffect(() => {
    return async () => {
      await ResetContactDataAction(dispatch);
    };
  }, []);
  const handleClick = (event) => {
    setShowPopover(!showPopover);
    setTarget(event.target);
  };

  const toastConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
  };

  const popoverContent = (
    <Popover className="custom-popover-style-contact p-1">
      <Row className="flex-column">
        <Col>
          <p className="custom-style-border1 p-1 m-0">
            <img
              src={TrashIcon}
              width={17}
              height={17}
              alt="trash"
              className="mr-2 p-0"
            />
            Contact Delete
          </p>
        </Col>
        <Col>
          <p className="custom-style-border2 p-1 m-0">
            <img
              src={BlockIcon}
              width={17}
              height={17}
              alt="block"
              className="mr-2 p-0"
            />
            Contact Block
          </p>
        </Col>
      </Row>
    </Popover>
  );

  const getInitials = (fullName) => {
    if (fullName) {
      const nameParts = fullName.split(" ");
      const firstTwoWords = nameParts.slice(0, 2);
      return firstTwoWords
        .map((part) => part[0])
        .join("")
        .toUpperCase();
    } else {
      return "";
    }
  };
  const initials = getInitials(data?.name);

  const objectLength = data ? Object.keys(data).length : 0;
  return (
    <>
      {objectLength ? (
        <>
          <Row>
            {loader ? (
              <div className="loader-contactDetails">
                <div className="wrapper">
                  <div className="circle"></div>
                  <div className="line-1"></div>
                  <div className="line-2"></div>
                  <div className="line-3"></div>
                  <div className="line-4"></div>
                  <div className="line-5"></div>
                  <div className="line-6"></div>
                  <div className="line-7"></div>
                  <div className="line-8"></div>
                  <div className="line-9"></div>
                  <div className="line-10"></div>
                  <div className="line-11"></div>
                  <div className="line-12"></div>
                </div>
              </div>
            ) : (
              <>
                <Col md={8}>
                  <Container className="pl-0">
                    <Row className="mt-4">
                      <Col md={2}>
                        {/* <small className='custom-bg-contactSection-top '>{initials}</small> */}
                        <Image
                          src={`https://ui-avatars.com/api/?name=${initials}&background=172e57&color=fff&size=40`}
                          roundedCircle
                          className="custom-avatar"
                        />
                      </Col>
                      <Col className="d-flex flex-column p-0">
                        <p className="message-p-tag-large">{data?.name}</p>
                        <p>{data?.phone}</p>
                      </Col>
                    </Row>
                    <Row className="mt-5">
                      <Col className="d-flex">
                        <p
                          className="contact-p-tag-large mr-3 cursor-pointer"
                          onClick={() => setShowData("About")}
                        >
                          About
                        </p>
                        <p
                          className="contact-p-tag-large mr-3"
                          onClick={() => setShowData("Notes")}
                        >
                          Notes
                        </p>
                        <p
                          className="contact-p-tag-large mr-3"
                          onClick={() => setShowData("Updates")}
                        >
                          Updates
                        </p>
                      </Col>
                    </Row>
                    {showData === "About" ? (
                      <Row style={{ overflow: "auto", height: "58vh" }}>
                        <Col>
                          {data?.name ? (
                            <p>
                              <strong>Name: </strong>
                              {data?.name}
                            </p>
                          ) : (
                            ""
                          )}
                          {data?.phone ? (
                            <p>
                              <strong>Phone Number: </strong>
                              {data?.phone}
                            </p>
                          ) : (
                            ""
                          )}
                          {data?.email ? (
                            <p>
                              <strong>Email: </strong>
                              {data?.email}
                            </p>
                          ) : (
                            ""
                          )}
                          {data?.country ? (
                            <p>
                              <strong>Contry: </strong>
                              {data?.country}
                            </p>
                          ) : (
                            ""
                          )}
                          {data?.companyName ? (
                            <p>
                              <strong>Company Name: </strong>
                              {data?.companyName}
                            </p>
                          ) : (
                            ""
                          )}
                          {data?.address ? (
                            <p>
                              <strong>Address: </strong>
                              {data?.address}
                            </p>
                          ) : (
                            ""
                          )}
                          {data?.city ? (
                            <p>
                              <strong>City: </strong>
                              {data?.city}
                            </p>
                          ) : (
                            ""
                          )}
                          {data?.state ? (
                            <p>
                              <strong>State: </strong>
                              {data?.state}
                            </p>
                          ) : (
                            ""
                          )}
                          {data?.zipCode ? (
                            <p>
                              <strong>Zipcode: </strong>
                              {data?.zipCode}
                            </p>
                          ) : (
                            ""
                          )}
                          <div>
                            {data?.customFields?.map((obj, index) => (
                              <div key={index}>
                                {Object.entries(obj).map(
                                  ([key, value]) =>
                                    key !== "id" && (
                                      <p key={key}>
                                        <strong>
                                          {key.charAt(0).toUpperCase() +
                                            key.slice(1)}
                                          :
                                        </strong>{" "}
                                        {value}
                                      </p>
                                    ),
                                )}
                              </div>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    {showData === "Notes" ? (
                      <>
                        <Row>
                          <Col>
                            {data.notes?.map((obj, index) => (
                              <div key={index}>
                                {Object.entries(obj).map(
                                  ([key, value]) =>
                                    key !== "id" && <li key={key}>{value}</li>,
                                )}
                              </div>
                            ))}
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col>
                            <a
                              onClick={handleShowNoteModal}
                              className="custom-a-tag"

                            >
                              Add Note
                            </a>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                    {showData === "Updates" ? (
                      <Row>
                        <Col>
                          {data?.updates?.map((item, index) => {
                            const formattedDate = moment(
                              item?.createdAt,
                            ).format("ddd DD MMM YYYY");
                            const formattedTime = moment(
                              item?.createdAt,
                            ).format("h:mm A");
                            return (
                              <div key={index}>
                                <small>{formattedDate}</small>
                                <div
                                  className=" d-flex mt-3 custom-div"
                                  onClick={handleShowMessageModal}
                                >
                                  <p>{formattedTime}</p>
                                  <p className="ml-4">
                                    {" "}
                                    Called {item.accountID} and left a message
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                  </Container>
                </Col>
                <Col className="custom-icon-style d-flex justify-content-end mr-5 mt-5">
                  <img
                    src={CallIcon}
                    alt="call"
                    width={20}
                    height={20}
                    className="mr-3"
                  />
                  <img
                    src={ChatIcon}
                    alt="chat"
                    width={20}
                    height={20}
                    className="mr-3"
                  />
                  <img
                    src={EditIcon}
                    alt="edit"
                    width={20}
                    height={20}
                    className="mr-3"
                    onClick={handleShow}
                  />
                  <BsThreeDotsVertical
                    size={20}
                    onClick={handleClick}
                    color="#abacae"
                  />
                  <Overlay show={showPopover} target={target} placement="left">
                    {popoverContent}
                  </Overlay>
                </Col>
              </>
            )}
          </Row>
        </>
      ) : (
        ""
      )}

      <EditContact show={showModal} handleClose={handleClose} data={data} />
      <ContactMessage
        show={showMessageModal}
        handleClose={handleCloseMessageModal}
        data={data?.updates}
      />
      <AddContactNoteModal
        show={showNoteModal}
        handleClose={handleCloseNoteModal}
        data={data}
      />
    </>
  );
}
